import React from 'react';
import IndexSearchForm from './indexSearchForm';

export default () => {
  const { dictionary } = startup;

  return (
    <>
      <div className="section-area bg-light">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="b-find">
                <div className="b-find-content tab-content" id="findTabContent">
                  <div className="tab-pane fade show active">
                    <IndexSearchForm />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*<div className="section-area bg-light">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="b-find">
                <h2 className="ui-title discount-message">
                  {dictionary.DiscountMessage}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>*/}
    </>
  );
};
